var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncreaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.102,
    x2: 0,
    y2: 0.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e87f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68a6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.186,
    y1: -0.058,
    x2: -0.149,
    y2: 1.076,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68abf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68a6f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1370",
    "data-name": "Groupe 1370",
    transform: "translate(-142 -1229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_119",
    "data-name": "Trac\\xE9 119",
    d: "M1346.391-154.923a23.527,23.527,0,0,1-23.5-23.5,23.527,23.527,0,0,1,23.5-23.5,23.527,23.527,0,0,1,23.5,23.5A23.527,23.527,0,0,1,1346.391-154.923Zm0-45a21.524,21.524,0,0,0-21.5,21.5,21.524,21.524,0,0,0,21.5,21.5,21.525,21.525,0,0,0,21.5-21.5A21.525,21.525,0,0,0,1346.391-199.923Z",
    transform: "translate(-1180.891 1430.923)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_115",
    "data-name": "Trac\\xE9 115",
    d: "M28.967,8.394a1.35,1.35,0,1,1-2.7,0V6.616l-9.811,9.837a1.35,1.35,0,0,1-1.845.063l-4.45-3.893L4.3,18.479A1.35,1.35,0,0,1,2.4,16.57l6.75-6.75a1.35,1.35,0,0,1,1.844-.061l4.448,3.892L24.365,4.7H22.252a1.35,1.35,0,1,1,0-2.7h5.367a1.35,1.35,0,0,1,1.35,1.35ZM22.25,16.85A1.35,1.35,0,0,1,23.6,15.5h4.05a1.35,1.35,0,1,1,0,2.7H23.6A1.35,1.35,0,0,1,22.25,16.85ZM13.475,20.9a1.35,1.35,0,0,0,0,2.7h4.05a1.35,1.35,0,0,0,0-2.7ZM2,27.65A1.35,1.35,0,0,1,3.35,26.3H7.4a1.35,1.35,0,1,1,0,2.7H3.35A1.35,1.35,0,0,1,2,27.65Zm10.125,0a1.35,1.35,0,0,1,1.35-1.35h4.05a1.35,1.35,0,1,1,0,2.7h-4.05A1.35,1.35,0,0,1,12.125,27.65Zm10.125,0A1.35,1.35,0,0,1,23.6,26.3h4.05a1.35,1.35,0,1,1,0,2.7H23.6A1.35,1.35,0,0,1,22.25,27.65ZM23.6,20.9a1.35,1.35,0,0,0,0,2.7h4.05a1.35,1.35,0,1,0,0-2.7Z",
    transform: "translate(150 1237)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon);
export default __webpack_public_path__ + "static/media/IncreaseIcon.3b8f9c0aca0a1a16639fc4260e96b966.svg";
export { ForwardRef as ReactComponent };